// extracted by mini-css-extract-plugin
module.exports = {"indicator":"styles_indicator__rLpEj","skeleton-animation":"styles_skeleton-animation__Ai1An"};